<template>
  <div>
    <modal name="detalheSugestao" height="auto" width="640" :scrollable="true">
      <CloseModal :close="closeDetalhe" />
      <div class="modalbox">
        <div class="modalbox-content">
          <div class="detalhe-header">
            <h5 class="detalhe-title">Detalhes da Sugestão</h5>
            <span
              v-if="currentItem"
              class="badge detalhe-badge"
              :class="situacaoBadge(currentItem.situacao)"
            >
              {{ situacaoLabel(currentItem.situacao) }}
            </span>
          </div>

          <div v-if="currentItem" class="detalhe-body">
            <div class="detalhe-descricao-box">
              <label class="section-label">Produto Sugerido</label>
              <p class="detalhe-descricao-text">{{ currentItem.descricao }}</p>
              <div class="detalhe-qty">
                <span class="detalhe-qty-label">Quantidade:</span>
                <span class="detalhe-qty-value">{{ currentItem.quantidade }}</span>
              </div>
            </div>

            <div class="detalhe-grid">
              <div class="detalhe-field">
                <label class="section-label">Colaborador</label>
                <p>{{ currentItem.colaborador_nome || '-' }}</p>
              </div>
              <div class="detalhe-field">
                <label class="section-label">Cliente</label>
                <p>{{ currentItem.cliente_id ? `${currentItem.cliente_id} - ${currentItem.cliente_nome || ''}` : '-' }}</p>
              </div>
              <div class="detalhe-field">
                <label class="section-label">Data de Criação</label>
                <p>{{ currentItem.datahora_criacao | datetime }}</p>
              </div>
            </div>

            <div v-if="currentItem.observacao" class="detalhe-obs">
              <label class="section-label">Observação</label>
              <p>{{ currentItem.observacao }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-bar" v-if="currentItem && currentItem.situacao === 'P'">
        <CButton variant="outline" color="secondary" @click="rejeitar(currentItem)">
          Rejeitar
        </CButton>
        <CButton color="primary" @click="aprovar(currentItem)">
          Aprovar
        </CButton>
      </div>
    </modal>

    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Sugestões de Compra de Produto">
        <!-- Summary Cards -->
        <div class="summary-row">
          <div
            class="summary-card"
            :class="{ active: filtroSituacao === '' }"
            @click="setFiltro('')"
          >
            <span class="summary-value">{{ totalGeral }}</span>
            <span class="summary-label">Total</span>
          </div>
          <div
            class="summary-card summary-pendente"
            :class="{ active: filtroSituacao === 'P' }"
            @click="setFiltro('P')"
          >
            <span class="summary-value">{{ totalPendentes }}</span>
            <span class="summary-label">Pendentes</span>
          </div>
          <div
            class="summary-card summary-aprovada"
            :class="{ active: filtroSituacao === 'A' }"
            @click="setFiltro('A')"
          >
            <span class="summary-value">{{ totalAprovadas }}</span>
            <span class="summary-label">Aprovadas</span>
          </div>
          <div
            class="summary-card summary-rejeitada"
            :class="{ active: filtroSituacao === 'R' }"
            @click="setFiltro('R')"
          >
            <span class="summary-value">{{ totalRejeitadas }}</span>
            <span class="summary-label">Rejeitadas</span>
          </div>
        </div>

        <table-paginated
          :itens="sugestoes"
          :columns="columns"
          :paginator="paginator"
          :onPageChange="onPageChange"
          :isLoadingData="loading"
          :showActions="true"
          :onUpdate="openDetalhe"
          :disableDelete="() => true"
        >
          <template v-slot:situacao="{ model }">
            <span class="badge" :class="situacaoBadge(model.situacao)">
              {{ situacaoLabel(model.situacao) }}
            </span>
          </template>

          <template v-slot:action-buttons="{ model }">
            <CButton
              v-if="model.situacao === 'P'"
              size="sm"
              color="success"
              @click.stop="aprovar(model)"
              title="Aprovar"
              class="mr-1"
            >
              <fa-icon icon="check" />
            </CButton>
            <CButton
              v-if="model.situacao === 'P'"
              size="sm"
              color="danger"
              @click.stop="rejeitar(model)"
              title="Rejeitar"
              class="mr-1"
            >
              <fa-icon icon="times" />
            </CButton>
          </template>
        </table-paginated>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import { get, put } from "@/helpers/apiRequest";
import { alertOnSuccess, alertOnError } from "@/helpers/crud";
import TablePaginated from "../../components/crud/TablePaginated";
import CloseModal from "../../components/CloseModal";

export default {
  name: "sugestoes-compra",
  components: { TablePaginated, CloseModal },
  data() {
    return {
      loading: false,
      sugestoes: [],
      paginator: null,
      currentItem: null,
      filtroSituacao: "P",
      currentPage: 1,
      totais: { total: 0, pendentes: 0, aprovadas: 0, rejeitadas: 0 },
      columns: [
        { label: "ID", field: "id", sortable: false },
        {
          label: "Colaborador",
          field: "colaborador_nome",
          sortable: false,
          representedAs: (row) => row.colaborador_nome || "-",
        },
        {
          label: "Cliente",
          field: "cliente_nome",
          sortable: false,
          representedAs: (row) =>
            row.cliente_id
              ? `${row.cliente_id} - ${row.cliente_nome || ""}`
              : "-",
        },
        { label: "Descrição", field: "descricao", sortable: false },
        { label: "Qtd", field: "quantidade", sortable: false },
        {
          label: "Situação",
          field: "situacao",
          sortable: false,
          useSlot: true,
        },
        {
          label: "Data",
          field: "datahora_criacao",
          sortable: false,
          representedAs: (row) =>
            row.datahora_criacao
              ? new Date(row.datahora_criacao).toLocaleDateString("pt-BR")
              : "-",
        },
      ],
    };
  },
  computed: {
    totalGeral() {
      return this.totais.total;
    },
    totalPendentes() {
      return this.totais.pendentes;
    },
    totalAprovadas() {
      return this.totais.aprovadas;
    },
    totalRejeitadas() {
      return this.totais.rejeitadas;
    },
  },
  methods: {
    loadSugestoes(page = 1) {
      this.loading = true;
      let url = `/admin/sugestoes-compra?page=${page}`;
      if (this.filtroSituacao) {
        url += `&situacao=${this.filtroSituacao}`;
      }
      get(url)
        .then((json) => {
          this.sugestoes = json.itens || [];
          this.paginator = json.paginator || null;
          this.loading = false;
        })
        .catch((err) => {
          alertOnError(err);
          this.loading = false;
        });
    },
    loadTotais() {
      get("/admin/sugestoes-compra")
        .then((json) => {
          const items = Array.isArray(json) ? json : json.itens || [];
          this.totais = {
            total: items.length,
            pendentes: items.filter((i) => i.situacao === "P").length,
            aprovadas: items.filter((i) => i.situacao === "A").length,
            rejeitadas: items.filter((i) => i.situacao === "R").length,
          };
        })
        .catch(() => {});
    },
    setFiltro(situacao) {
      this.filtroSituacao = situacao;
      this.currentPage = 1;
      this.loadSugestoes(1);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadSugestoes(page);
    },
    openDetalhe(item) {
      this.currentItem = item;
      this.$modal.show("detalheSugestao");
    },
    closeDetalhe() {
      this.$modal.hide("detalheSugestao");
      this.currentItem = null;
    },
    aprovar(item) {
      put(`/admin/sugestoes-compra/${item.id}/situacao`, { situacao: "A" })
        .then(() => {
          alertOnSuccess("Sugestão aprovada com sucesso");
          this.closeDetalhe();
          this.loadSugestoes(this.currentPage);
          this.loadTotais();
        })
        .catch(alertOnError);
    },
    rejeitar(item) {
      put(`/admin/sugestoes-compra/${item.id}/situacao`, { situacao: "R" })
        .then(() => {
          alertOnSuccess("Sugestão rejeitada");
          this.closeDetalhe();
          this.loadSugestoes(this.currentPage);
          this.loadTotais();
        })
        .catch(alertOnError);
    },
    situacaoLabel(s) {
      const labels = { P: "Pendente", A: "Aprovada", R: "Rejeitada" };
      return labels[s] || s;
    },
    situacaoBadge(s) {
      const badges = {
        P: "badge-warning",
        A: "badge-success",
        R: "badge-danger",
      };
      return badges[s] || "badge-secondary";
    },
  },
  beforeMount() {
    this.loadSugestoes();
    this.loadTotais();
  },
};
</script>

<style scoped>
/* Summary Cards */
.summary-row {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  margin-top: 4px;
}

.summary-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 12px;
  border-radius: 10px;
  border: 1px solid #e4e7eb;
  background: #fff;
  cursor: pointer;
  transition: all 150ms ease;
}

.summary-card:hover {
  border-color: #3a3e81;
  background: #f9f9fc;
}

.summary-card.active {
  border-color: #3a3e81;
  background: #eceaf3;
}

.summary-value {
  font-size: 22px;
  font-weight: 700;
  color: #3a3e81;
  line-height: 1;
}

.summary-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #888;
  margin-top: 4px;
  letter-spacing: 0.03em;
}

.summary-pendente .summary-value {
  color: #dc7909;
}
.summary-aprovada .summary-value {
  color: #38a512;
}
.summary-rejeitada .summary-value {
  color: #b33630;
}

.summary-pendente.active {
  border-color: #dc7909;
  background: #fef3e0;
}
.summary-aprovada.active {
  border-color: #38a512;
  background: #e8f3e4;
}
.summary-rejeitada.active {
  border-color: #b33630;
  background: #f3e7e7;
}

/* Detalhe Modal */
.detalhe-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dddce9;
}

.detalhe-title {
  font-size: 16px;
  font-weight: 700;
  color: #3a3e81;
  margin: 0;
}

.detalhe-badge {
  font-size: 12px;
  padding: 4px 10px;
}

.detalhe-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
}

.detalhe-descricao-box {
  padding: 14px;
  border-radius: 8px;
  background: #f2f2f8;
  border: 1px solid #dddce9;
}

.detalhe-descricao-text {
  font-size: 15px;
  font-weight: 500;
  color: #222;
  margin-bottom: 8px;
  line-height: 1.4;
}

.detalhe-qty {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.detalhe-qty-label {
  font-size: 12px;
  color: #888;
}

.detalhe-qty-value {
  font-size: 14px;
  font-weight: 700;
  color: #3a3e81;
}

.detalhe-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
}

.detalhe-field p {
  font-size: 14px;
  color: #333;
  margin: 0;
}

.detalhe-obs {
  padding: 12px;
  border-radius: 8px;
  background: #fafafa;
  border: 1px solid #eee;
}

.detalhe-obs p {
  font-size: 13px;
  color: #555;
  margin: 0;
  line-height: 1.5;
}

/* Modal Footer */
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
